import styled, { css } from 'styled-components';
import { Buttons, FlexContainer, Text } from '@taxdown/piccolo-web';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Header = styled(FlexContainer)`
  width: 100%;
  background: ${({ theme: { colors } }) => colors.grad_500};
`;

export const InputTitle = styled(Text)`
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: none;
  }
`;

export const HeaderContent = styled(FlexContainer)`
  padding: ${({ theme: { sizing } }) => `${sizing.fds_size_40} ${sizing.fds_size_48}`};
  width: 100%;
  max-width: 1060px;

  @media screen and (max-width: ${MOBILE_WIDTH}) {
    padding: ${({ theme: { reference } }) => reference.dimension_24};
  }
`;

export const ShareInput = styled.input`
  width: 100%;
  color: ${({ theme: { colors } }) => colors.dark_500};
  background: ${({ theme: { colors } }) => colors.white};
  max-width: 712px;
  padding: ${({ theme: { sizing } }) => sizing.fds_size_16};
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_M} 0 0
    ${({ theme: { sizing } }) => sizing.fds_borderradius_M};
  border: 1px solid ${({ theme: { colors } }) => colors.moon_500};
  border-right: none;
  ${({ theme: { typography } }) => typography.fds_paragraph_medium_M};
  height: 62px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: none;
  }
`;

export const CopyButton = styled.button`
  background: ${({ theme: { colors } }) => colors.white};
  padding: ${({ theme: { sizing } }) => css`
    ${sizing.fds_size_16} ${sizing.fds_size_16} ${sizing.fds_size_16} 0
  `};
  border: 1px solid ${({ theme: { colors } }) => colors.moon_500};
  border-radius: ${({ theme: { sizing } }) =>
    css`0 ${sizing.fds_borderradius_M} ${sizing.fds_borderradius_M} 0`};
  border-left: none;
  height: 62px;
  cursor: pointer;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: none;
  }
`;

export const ShareButton = styled(Buttons.Classic)`
  min-width: 180px;
  margin-left: ${({ theme: { reference } }) => reference.dimension_08};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    margin: 0;
  }
`;

export const Link = styled(Text)`
  text-decoration: underline;

  @media screen and (max-width: ${MOBILE_WIDTH}) {
    text-align: center;
  }
`;
